import { RootState } from '€slices/types';

export const getRequestResetEmailSuccess = (state: RootState) =>
    state.passwordReset.requestEmailSuccess;

export const getRequestResetEmailSuccessEmail = (state: RootState) =>
    state.passwordReset.requestEmailSuccessEmail;

export const getRequestingResetEmail = (state: RootState) => state.passwordReset.requestingEmail;

export const getResetPasswordSuccess = (state: RootState) => state.passwordReset.resetSuccess;
export const getResettingPassword = (state: RootState) => state.passwordReset.resetting;

export const getResetPasswordError = (state: RootState) => state.passwordReset.resetError;
export const getResetPasswordDidFailed = (state: RootState) => state.passwordReset.resetFailed;

export const getResetTokenValidationState = (state: RootState) =>
    state.passwordReset.resetTokenValidateState;
export const getValidResetToken = (state: RootState) => state.passwordReset.validResetToken;
